import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { getMaxScheduleDate, getMinScheduleDate } from "../../utils/dateUtils";

export const LiveSessionScheduleDateInput = ({
  disabled,
  value,
  hasError,
  errorMessage,
  errorMessageValues,
  onChange,
}) => {
  const intl = useIntl();

  const getErrorMessage = () =>
    intl.formatMessage(
      {
        id: errorMessage,
      },
      errorMessageValues
    );

  return (
    <GridItem gridRow={3} gridColumn="1 / span 8" marginTop={3}>
      <Grid gridRowGap={0} style={{ justifyContent: "space-between" }}>
        <GridItem gridRow="1" gridColumn="1 / span 8">
          <Text as="label" htmlFor="liveSessionDate" size="tiny" marginBottom={2} display="block">
            <FormattedMessage id="live_sessions.schedule_new.date_input.label" />
          </Text>
          <Form.Input
            size="medium"
            id="liveSessionDate"
            name="liveSessionDate"
            type="date"
            min={getMinScheduleDate()}
            max={getMaxScheduleDate()}
            value={value}
            hasError={hasError}
            disabled={disabled}
            autoComplete="off"
            onChange={(event) => onChange(event.target.value)}
          />
        </GridItem>
        {errorMessage && (
          <GridItem gridRow="2" gridColumn="1 / span 8">
            <Form.Error textAlign="left">{getErrorMessage()}</Form.Error>
          </GridItem>
        )}
      </Grid>
    </GridItem>
  );
};

LiveSessionScheduleDateInput.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.string,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  /* eslint-disable-next-line react/forbid-prop-types */
  errorMessageValues: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

LiveSessionScheduleDateInput.defaultProps = {
  disabled: false,
  value: "",
  hasError: false,
  errorMessage: "",
  errorMessageValues: {},
};

export default LiveSessionScheduleDateInput;
